<script setup lang="ts">
import Banner from './@components/Icons/Banner.vue'

const { colors } = useTheme()
</script>

<template>
  <section w-full mb-20px>
    <div flex="~ col" items-center justify-center>
      <Banner max-w-454px w-full pl-20px pr-20px />

      <div flex="~ row <md:col" w-full items-center justify-center space-x="120px <md:0">
        <h2 style="font-family: Circular Std Bold, sans-serif" text="112px <md:80px">
          Magic.
        </h2>

        <h3 w="400px <md:full" max-w-360px text="left <md:center" :style="{ 'font-family': 'Circular Std Book, sans-serif', 'color': colors.darkerGray }" text-16px m="0 <md:20px">
          Amplify ChatGPT capabilities with a suite of magical features designed to speed up your AI tasks.
        </h3>
      </div>
    </div>
  </section>
</template>

<style lang="scss" module>
.listItem {
  --at-apply: ml-4 flex gap-2;
}
.gradient-text {
  font-size: 20px;
  font-weight: bold;
  background: linear-gradient(#FF88EC, #A993FF, #2376E5);
  background-clip: text;
  color: transparent;
}
</style>
